import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
/**
 * Styles used for the rendering of the flyout footer links.
 */
export var useFlyoutLinkStyles = makeStyles({
    appAcquisitionLink: __assign(__assign(__assign({ fontWeight: tokens.fontWeightSemibold, fontSize: tokens.fontSizeBase200 }, shorthands.borderWidth(0)), shorthands.padding('0px', '10px')), { '&:hover': {
            backgroundColor: tokens.colorTransparentBackgroundPressed,
        }, '&:active:hover': {
            backgroundColor: tokens.colorTransparentBackgroundPressed,
        }, ':focus-visible': {
            backgroundColor: tokens.colorNeutralBackground4Selected,
            boxShadow: 'none',
            outlineStyle: 'solid',
            outlineWidth: '2px',
            outlineOffset: '-2px',
            outlineColor: tokens.colorNeutralStrokeAccessible,
        } }),
    appAcquisitionLinkButton: __assign(__assign(__assign(__assign({}, shorthands.borderRadius('4px')), { fontWeight: tokens.fontWeightSemibold, fontSize: tokens.fontSizeBase200 }), shorthands.padding('0px', '10px')), { ':focus-visible': {
            boxShadow: 'none',
            outlineStyle: 'solid',
            outlineWidth: '2px',
            outlineOffset: '-2px',
            outlineColor: tokens.colorNeutralStrokeAccessible,
        } }),
    appAcquisitionLinkContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: tokens.colorNeutralForeground1,
    },
    appAcquisitionLinkContainer: __assign({ display: 'flex', flexDirection: 'row', marginTop: '2px' }, shorthands.gap('4px')),
    appAcquisitionLinkLabel: {
        marginTop: '6px',
        fontSize: tokens.fontSizeBase300,
    },
    appAcquisitionLinkIcon: {
        marginTop: '5px',
    },
    appAcquisitionLinkContainerReversed: __assign({ display: 'flex', marginTop: '4px', flexDirection: 'row-reverse' }, shorthands.gap('7px')),
    appAcquisitionLinkLabelReversed: {
        marginTop: '0px',
        marginRight: '0px',
    },
    appAcquisitionLinkIconReversed: {
        marginTop: '0px',
    },
});
//# sourceMappingURL=FlyoutFooterLink.styles.js.map